import React from 'react';
import MyService from '../../MyService/MyService';
import About from '../About/About';
import AboutMe from '../AboutMe/AboutMe';
import AllProjects from '../AllProjects/AllProjects'
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';

const Home = () => {
    return (
        <div style={{backgroundColor:'black'}}>
           <AboutMe></AboutMe>
           <MyService></MyService>
           <AllProjects></AllProjects>
           <About></About>
           <Contact></Contact>
           <Footer></Footer>
        </div>
    );
};

export default Home;